function QuotationMarkEndSvg() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="39" height="30" fill="none"><path fill="#868993" d="M31.224 13.98c-3.877-.102-7.143-2.858-7.143-6.94 0-3.877 3.062-7.04 7.143-7.04 4.388 0 7.041 3.265 7.041 7.96 0 8.673-8.571 18.366-17.55 22.04L20 28.878c5.204-3.062 11.122-8.572 11.224-14.898Zm-20 0c-3.877-.103-7.143-2.858-7.143-6.94C4.081 3.164 7.143 0 11.224 0c4.388 0 7.041 3.265 7.041 7.96 0 8.673-8.571 18.366-17.55 22.04L0 28.878c5.204-3.062 11.122-8.572 11.224-14.898Z" /></svg>)
}

export default QuotationMarkEndSvg
